module.exports = __webpack_public_path__ + "static/media/plus.405cc0a2.svg";